var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tags != ''),expression:"tags != ''"}]},[_c('p',{staticClass:"tags",domProps:{"innerHTML":_vm._s(_vm.list_tags)}})])}
var staticRenderFns = []

export { render, staticRenderFns }